// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthLayout_root__14BA2"};